<div class="is-fixed-top">
  <div class="container">
    <div class="columns">
      <div class="column is-one-third-desktop">
        {#if backPath}
          <p class="buttons">
            <button class="button" on:click="{() => push(backPath)}">
              <span class="icon is-small"> <i class="fas fa-home"></i> </span>
              <span>Zur Übersicht</span>
            </button>
          </p>
        {/if}
      </div>
      <div class="column has-text-right">
        <LogoutBtn />
      </div>
    </div>
  </div>
</div>

<script>
import { push } from "svelte-spa-router";
import { onMount } from "svelte";
import LogoutBtn from "./LogoutBtn.svelte";

export let params = {};
export let backPath;
</script>

<style type="text/scss">
@import "./scss/colors";
@import "./scss/shared";
.is-clickable {
  cursor: pointer;
}
</style>
